import { localeAtom, mobilePageTitleAtom } from 'config/store'
import i18n from 'i18n'
import { useAtom } from 'jotai'
import { useEffect, useState } from 'react'
import { Container, Form, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import acceptInviteIcon from 'assets/images/profilepage-invite-accept.svg'
import iconVi from 'assets/images/Vietnam.svg.png'
import iconLA from 'assets/images/Lao.svg.png'
import iconEN from 'assets/images/eng.png'
import { useUpdateSetting } from 'dataLayer/user'

function SettingMobile({ title }) {
	const { t } = useTranslation()

	const [, setMobilePageTitle] = useAtom(mobilePageTitleAtom)
	const i18nextLng = localStorage.getItem('i18nextLng')
	const [language, setLanguage] = useState(i18nextLng)
	const [backgroundMusic, setBackgroundMusic] = useState(false)
	const { mutate } = useUpdateSetting(() => { })

	useEffect(() => {
		setMobilePageTitle(title)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [language])

	const [locale, setLocale] = useAtom(localeAtom)
	const changeLanguage = lng => {
		i18n.changeLanguage(lng)
		mutate({
			language: lng,
		})
	}
	const handleChangeMusic = e => {
		setBackgroundMusic(e.target.checked)
		mutate({
			background_music: e.target.checked ? 1 : 0,
		})
	}
	return (
		<Container fluid className="px-3 px-sm-5">
			<Row className="profilepage-content__body setting setting-mobile mt-3">
				<Row className="profilepage-content__title ms-4">
					{t('mobile.setting.sounds')}
				</Row>
				<Row className="content">
					<p>{t('profile.setting.bg_music')}</p>
					<Form>
						<Form.Check
							type="switch"
							defaultChecked={backgroundMusic}
							onChange={handleChangeMusic}
						/>
					</Form>
				</Row>
				{/* <Row className="content">
					<p>{t('profile.setting.bg_music')}</p>
					<Form>
						<Form.Check type="switch" />
					</Form>
				</Row> */}
			</Row>
			<Row className="profilepage-content__body setting setting-mobile my-3">
				<Row className="profilepage-content__title ms-4">
					{t('mobile.setting.lang')}
				</Row>
				<Row
					className="content"
					onClick={() => {
						changeLanguage('en')
						setLocale('en')
						setLanguage('en')
					}}
				>
					<div style={{ width: '50%', display: 'inherit' }}>
						<img
							style={{ width: 24, height: 20, marginRight: 20 }}
							src={iconEN}
							alt="en"
						/>
						<p>{t('profile.setting.en')}</p>
					</div>

					{i18nextLng === 'en' ? (
						<img src={acceptInviteIcon} alt="English" />
					) : null}
				</Row>
				<Row
					className="content"
					onClick={() => {
						changeLanguage('la')
						setLocale('la')
						setLanguage('la')
					}}
				>
					<div style={{ width: '50%', display: 'inherit' }}>
						<img
							style={{ width: 24, height: 20, marginRight: 20 }}
							src={iconLA}
							alt="la"
						/>
						<p>{t('profile.setting.la')}</p>
					</div>

					{i18nextLng === 'la' ? (
						<img src={acceptInviteIcon} alt="Laotian" />
					) : null}
				</Row>
				<Row
					className="content"
					onClick={() => {
						changeLanguage('vi')
						setLocale('vi')
						setLanguage('vi')
					}}
				>
					<div style={{ width: '50%', display: 'inherit' }}>
						<img
							style={{ width: 24, height: 20, marginRight: 20 }}
							src={iconVi}
							alt="en"
						/>
						<p>{t('profile.setting.vi')}</p>
					</div>
					{i18nextLng === 'vi' ? (
						<img src={acceptInviteIcon} alt="VietNamese" />
					) : null}
				</Row>
			</Row>
		</Container>
	)
}

export default SettingMobile
